import React from 'react'

const PreviousBooking = ({ info }) => {
  return (
    <div className='occupied' style={{ gridColumn: 1+info.col, gridRow: `${info.row} / span ${info.size}` }}>
    </div>
  )
}

export default PreviousBooking
